// extracted by mini-css-extract-plugin
module.exports = {"container":"select-workspace-modal_container_zzJ","content":"select-workspace-modal_content_Yop","header":"select-workspace-modal_header_1zK"};